function JobDetailsTable({ title, jobs }) {
  if (!jobs || jobs.length === 0) {
    return (
      <div className="job-details">
        <h2>{title}</h2>
        <p className="no-jobs-message">-</p>
      </div>
    );
  }

  // Detect job type based on the first job's data structure
  const isAudioPlayListJob = jobs?.[0]?.data?.playList;
  const isAudioAbbreviationJob = jobs?.[0]?.data?.replacement;

  return (
    <div className="job-details">
      <h2>{title}</h2>
      <table className="details-table">
        <thead>
          <tr>
            <th>Job ID</th>
            {isAudioPlayListJob && (
              <>
                <th>Chapter ID</th>
                <th>Voice</th>
                <th>Questions</th>
              </>
            )}
            {isAudioAbbreviationJob && (
              <>
                <th>Text</th>
                <th>Replacement</th>
                <th>Type</th>
              </>
            )}
          </tr>
        </thead>
        <tbody>
          {jobs.map((job) => (
            <tr key={job.id}>
              <td>{job.id}</td>
              {isAudioPlayListJob && (
                <>
                  <td>{job.data.playList.chapter}</td>
                  <td>{job.data.voice.decodeName}</td>
                  <td>{Object.keys(job.data.questions).length}</td>
                </>
              )}
              {isAudioAbbreviationJob && (
                <>
                  <td>{job.data.text}</td>
                  <td>{job.data.replacement}</td>
                  <td>{job.data.type}</td>
                </>
              )}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default JobDetailsTable;
